interface Array<T> {
    asyncForEach(callback: (element: T, index: number, array: Array<T>) => Promise<void>);
    first(predicate: (element: T) => boolean);
}

if (!Array.prototype.asyncForEach){
    Array.prototype.asyncForEach = async function <T>(this: T[], callback: (element: T, index: number, array: Array<T>) => Promise<void>) {
        for (let index = 0; index < this.length; index++) {
            await callback(this[index], index, this);
        }
    }
}

if (!Array.prototype.first) {
    Array.prototype.first = function <T>(this: T[], predicate: (element: T) => boolean) {
        for (let index = 0; index < this.length; index++) {
            if (predicate(this[index])) {
                return this[index];
            }
        }
        return null;
    }
}